module.exports = __webpack_public_path__ + "img/fleet-battle-logoNew1-512.81bba299.png";